export default "__VITE_ASSET__5d33675f__"